module.exports = __webpack_public_path__ + "img/dragonfly.be5030ca.webp";